import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "./NewsDetails.css";
import SimpleSlider from "../component/Slider";
import { FaArrowLeft, FaTimes, FaChevronLeft, FaChevronRight } from "react-icons/fa";

const NewsDetails = ({ post, onBack }) => {
  const { title, text, date, link, story, picture } = post;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalIndex, setModalIndex] = useState(0);

  const [images, setImages] = useState([]);

  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchAllImages = async () => {
      try {
        const res = await fetch(`${API_URL}/api/posts/${post.id}/images`);
        const data = await res.json();
        setImages(data); 
      } catch (err) {
        console.error("Błąd pobierania zdjęć:", err);
      }
    };

    fetchAllImages();
  }, [post.id]);


  const openModal = (index) => {
    setModalIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  const prevImage = () =>
    setModalIndex((modalIndex + images.length - 1) % images.length);

  const nextImage = () =>
    setModalIndex((modalIndex + 1) % images.length);

  return (
    <div className="news-details">
      <div className="news-header">
        <button onClick={onBack} className="back-button">
          <FaArrowLeft />
        </button>

        <div className="news-info">
          <p className="news-date">{date}</p>
        </div>
      </div>

      <p className="news-text">{text}</p>

      <SimpleSlider
        slides={images}
        onClick={openModal} 
      />

      <div className="fb-link-container">
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="news-fb-link"
        >
          Zobacz na Facebooku
        </a>
      </div>

      {isModalOpen && (
        <div className="image-modal">
          <button className="close-btn" onClick={closeModal}>
            <FaTimes />
          </button>
          <button className="prev-btn" onClick={prevImage}>
            <FaChevronLeft />
          </button>
          <img src={images[modalIndex]} alt={`Zdjęcie ${modalIndex + 1}`} />
          <button className="next-btn" onClick={nextImage}>
            <FaChevronRight />
          </button>
        </div>
      )}
    </div>
  );
};

export default NewsDetails;
